/* eslint-disable import/first */

'use strict';
import '../scss/ionic.app.scss';
import 'opentok-solutions-css';
import 'rc-slider/assets/index.css';
import './_libs/rc-swipeout/index.css';

const appModule = require('./module');
const bootstrapModule = require('./core-utilities/app-bootstrap');


/**
 * Setup App Module
 */
appModule
  .config(['$logProvider', function ($logProvider) {
    $logProvider.debugEnabled(false);
  }])
  .run([
    '$window',
    '$injector',
    '$rootScope',
    '$ngRedux',
    '$state',
    '$timeout',
    '$toast',
    'AppBootstrapper',
    '$ionicPlatform',
    'FirebaseUtil',
    '$cordovaStatusbar',
    /* '$ionicAnalytics',*/
    /* 'ENVIRONMENT',*/
    /* 'ENVIRONMENTS',*/
    function (
      $window,
      $injector,
      $rootScope,
      $ngRedux,
      $state,
      $timeout,
      $toast,
      AppBootstrapper,
      $ionicPlatform,
      FirebaseUtil,
      $cordovaStatusbar,
      // $ionicAnalytics,
      // ENVIRONMENT,
      // ENVIRONMENTS,
    ) {

      $ionicPlatform.ready(function () {

        // if (ENVIRONMENT !== ENVIRONMENTS.DEVELOP) $ionicAnalytics.register();

        // Hide the accessory bar by default (remove this to show the accessory bar above the keyboard
        // for form inputs)
        if ($window.cordova && $window.cordova.plugins.Keyboard) {
          cordova.plugins.Keyboard.hideKeyboardAccessoryBar(true);
          cordova.plugins.Keyboard.disableScroll(ionic.Platform.isIOS());
          ionic.Platform.isFullScreen = false;
        }

        if ($window.navigator.splashscreen && $window.navigator.splashscreen.hide) {
          $timeout(function () {
            try {
              $window.navigator.splashscreen.hide();
            } catch (e) {
              console.error(e);
            }
          }, 2000);
        }

        if ($window.StatusBar) {
          // Set the statusbar to use the default style, tweak this to
          // remove the status bar on iOS or change it to use white instead of dark colors.
          if (ionic.Platform.isIOS() || ionic.Platform.isIPad()) {
            $cordovaStatusbar.overlaysWebView(false);
            $cordovaStatusbar.style(0);
            $cordovaStatusbar.styleColor("white");
          } else {
            $cordovaStatusbar.overlaysWebView(false);
          }
        }

        // Initialize services
        AppBootstrapper.loaded()
          .then(() =>
            Promise.all([
              'FirebaseConnectionService',
              'mobilePushService',
              'ApiVersionCheckService',
              '$toast',
              'NotificationService',
              'userPresenceService',
              'userPresenceService',
              'MapsService',
              'PersistentUploaderService',
            ].map(initService))
          )
          .catch(e => {
            console.warn('initialization failed');
            console.error(e);
          });


        // Upon successful logout, reset the user object and clear cookies
        FirebaseUtil.firebaseRef()
          .offAuth(event => $window.cookies.clear(() => console.log("Cookies cleared!")));

        // apply polyfills // TODO: needs improvement
        checkRequestAnimationFrame();

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
          event.preventDefault();
        });

        function initService(serviceName) {
          try {
            return Promise.resolve($injector.get(serviceName).init());
          } catch (e) {
            console.warn(`Failed to init "${serviceName}"`);
            console.error(e);
            return Promise.reject(e);
          }
        }
      });
    }]);

// Bootstrap App Module
// bootstrapModule.ionicBootstrap(appModule, global);


// Polyfill requestAnimationFrame && cancelAnimationFrame
function checkRequestAnimationFrame() {
  const vendors = ['ms', 'moz', 'webkit', 'o'];
  let lastTime = 0;
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => callback(currTime + timeToCall), timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/index.js